import { Mail, Phone, Instagram } from 'lucide-react';

const CONTACT_METHODS = [
  { key: 'email', icon: Mail, label: 'Email' },
  { key: 'phone', icon: Phone, label: 'Phone' },
  { key: 'instagram', icon: Instagram, label: 'Instagram' },
] as const;

interface ContactMethodTogglesProps {
  availableMethods: string[];
  selectedMethods: string[];
  onToggle: (method: string) => void;
  saving?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export function ContactMethodToggles({
  availableMethods,
  selectedMethods,
  onToggle,
  saving: _saving = false,
  disabled = false,
  size = 'sm',
}: ContactMethodTogglesProps) {
  const methods = CONTACT_METHODS.filter(m => availableMethods.includes(m.key));

  if (methods.length === 0) return null;

  const pill = size === 'sm'
    ? 'px-2.5 py-1 text-xs gap-1.5'
    : 'px-3 py-1.5 text-sm gap-2';
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5';

  return (
    <div className="flex flex-wrap gap-1.5">
      {methods.map(({ key, icon: Icon, label }) => {
        const selected = selectedMethods.includes(key);
        return (
          <button
            key={key}
            onClick={() => onToggle(key)}
            disabled={disabled}
            className={`inline-flex items-center rounded-full font-medium transition-all ${pill} ${
              selected
                ? 'bg-primary-500 text-white shadow-sm'
                : 'bg-neutral-100 dark:bg-neutral-800 text-dark-muted hover:bg-neutral-200 dark:hover:bg-neutral-700'
            } disabled:opacity-40 disabled:cursor-not-allowed`}
          >
            <Icon className={iconSize} />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
